import { gql } from "@apollo/client";

export const ToastMessageList = gql`
    query ToastMessageList ($filter: ToastMessageListFilter, $pagination: Pagination){
        toastMessageList(
            filter: $filter
        ) {
            total
            # newest announcements first — the table has no interactive sorting
            toastMessages(pagination: $pagination, sort: {fromDate: desc}) {
                id
                message
                fromDate
                toDate
                status
            }
        }
    }
`;
